import { ca } from '@cian/analytics';
import { EObjectType, TFilters } from '@cian/countryside-genplan-component';

export const trackGeplanShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'show',
    label: 'interactive_map',
    useLastProducts: true,
  });
};

export const trackObjectClick = (offerId: number, objectType: EObjectType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'click',
    label: 'object_polygon',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: {
          object_type: objectType,
        },
      },
    ],
  });
};

export const trackPhoneShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'open',
    label: 'phone_number',
    useLastProducts: true,
  });
};

export const trackPreviewClick = (offerId: number, clickedOfferId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'to_card',
    label: 'card_detail_in_new_list',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: {
          offer_id: clickedOfferId,
        },
      },
    ],
  });
};

export const trackGenplanOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'open',
    label: 'fullscreen',
    useLastProducts: true,
  });
};

export const trackFiltersChange = (offerId: number, filters: TFilters) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'genplan',
    action: 'click',
    label: 'filter',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: {
          filter_state: filters,
        },
      },
    ],
  });
};
